import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const RatingSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BottomFixedCTA = styled.div`
  position: fixed;
  width: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  padding: 0 12px 20px;
  max-width: 450px;
  bottom: 0px;
`;

export const ReviewGuideContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 10px;
`;

export const ReviewGuideText = styled.li`
  list-style-type: disc;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: ${colors.gray400};
`;

export const Section = styled.section`
  .textarea-wrapper:not(:last-of-type) {
    margin-bottom: 18px !important;
  }
`;
